export default __webpack_public_path__ + "static/media/1489.fb715728.png";